import React, { useState, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import Auth from '../../Helpers/auth';

const DiscountIcon = React.lazy(
  () => import('../../Visuals/Icons/DiscountIcon.icon')
);
const AddUserIcon = React.lazy(
  () => import('../../Visuals/Icons/AddUser.icon')
);
const PresentationIcon = React.lazy(
  () => import('../../Visuals/Icons/PresentationIcon.icon')
);
const OfficeIcon = React.lazy(
  () => import('../../Visuals/Icons/OfficeIcon.icon')
);
const LogoutIcon = React.lazy(
  () => import('../../Visuals/Icons/LogoutIcon.icon')
);
const NewsIcon = React.lazy(() => import('../../Visuals/Icons/NewsIcon.icon'));
const ImageIcon = React.lazy(() => import('../../Visuals/Icons/Image.icon'));
const FilesIcon = React.lazy(
  () => import('../../Visuals/Icons/FilesIcon.icon')
);
const DashboardIcon = React.lazy(
  () => import('../../Visuals/Icons/DashboardIcon.icon')
);
const DownIcon = React.lazy(
  () => import('../../Visuals/Icons/ChevronDown.icon')
);

const AdminSideMenu = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [openCategory, setOpenCategory] = useState(null);

  const toggleCategory = (category) => {
    setOpenCategory(openCategory === category ? null : category);
  };

  return (
    <Suspense fallback={<p>Loading menu icons...</p>}>
      <div className="sideMenu">
        {/* User Management */}
        <div>
          <div
            onClick={() => toggleCategory('userManagement')}
            className="menuCategory"
          >
            <h4 onClick={() => toggleCategory('userManagement')}>
              User Management
            </h4>
            <DownIcon functionName={() => toggleCategory('userManagement')} />
          </div>
          {openCategory === 'userManagement' && (
            <div className="menuItems">
              <Link className="subLink" to="/admin/create-user">
                <AddUserIcon />
                Create User
              </Link>
              {isMobile && (
                <Link className="subLink" to="/admin/users">
                  <FilesIcon />
                  Users
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Company Management */}
        <div>
          <div
            onClick={() => toggleCategory('companyManagement')}
            className="menuCategory"
          >
            <h4 onClick={() => toggleCategory('companyManagement')}>
              Company Management
            </h4>
            <DownIcon
              functionName={() => toggleCategory('companyManagement')}
            />
          </div>
          {openCategory === 'companyManagement' && (
            <div className="menuItems">
              <Link className="subLink" to="/admin/create-company">
                <OfficeIcon />
                Create Company
              </Link>
              <Link className="subLink" to="/admin/discounts">
                <DiscountIcon />
                Discounts
              </Link>
              {isMobile && (
                <Link className="subLink" to="/admin/companies">
                  <FilesIcon />
                  Companies
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Course Management */}
        <div>
          <div
            onClick={() => toggleCategory('courseManagement')}
            className="menuCategory"
          >
            <h4 onClick={() => toggleCategory('courseManagement')}>
              Course Management
            </h4>
            <DownIcon functionName={() => toggleCategory('courseManagement')} />
          </div>
          {openCategory === 'courseManagement' && (
            <div className="menuItems">
              <Link className="subLink" to="/admin/create-course">
                <PresentationIcon />
                Create Course
              </Link>
              <Link className="subLink" to="/admin/create-image">
                <ImageIcon />
                Upload Image
              </Link>
              {isMobile && (
                <Link className="subLink" to="/admin/courses">
                  <FilesIcon />
                  Courses
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Newsletter Management */}
        <div>
          <div
            className="menuCategory"
            onClick={() => toggleCategory('newsletterManagement')}
          >
            <h4 onClick={() => toggleCategory('newsletterManagement')}>
              Newsletter Management
            </h4>
            <DownIcon
              functionName={() => toggleCategory('newsletterManagement')}
            />
          </div>
          {openCategory === 'newsletterManagement' && (
            <div className="menuItems">
              <Link className="subLink" to="/admin/create-newsletter">
                <NewsIcon />
                Create Newsletter
              </Link>
              {isMobile && (
                <Link className="subLink" to="/admin/newsletters">
                  <FilesIcon />
                  Newsletters
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Miscellaneous */}
        <div>
          <div
            className="menuCategory"
            onClick={() => toggleCategory('miscellaneous')}
          >
            <h4 onClick={() => toggleCategory('miscellaneous')}>
              Miscellaneous
            </h4>
            <DownIcon functionName={() => toggleCategory('miscellaneous')} />
          </div>
          {openCategory === 'miscellaneous' && (
            <div className="menuItems">
              <Link className="subLink" to="/admin/information">
                <FilesIcon />
                Get Information
              </Link>
            </div>
          )}
        </div>

        {/* User Dashboard */}
        <Link
          className="subLink portal"
          style={{ marginTop: '1rem' }}
          to="/user"
        >
          <DashboardIcon />
          User Dashboard
        </Link>

        {/* Logout */}
        <Link
          onClick={(e) => {
            e.preventDefault();
            Auth.logout();
            window.location.assign('/');
          }}
          title="Logout"
          className="subLink "
          style={{ marginTop: '1rem' }}
          to="/about"
        >
          <LogoutIcon />
          Logout
        </Link>
      </div>
    </Suspense>
  );
};

export default AdminSideMenu;
